/**
 * Resolve brand integration code from brand / order-details payload.
 * Prefer brand.integration — never rely on order.serviceProvider for UI gating.
 */
export const resolveBrandIntegration = (source = {}) => {
  if (!source || typeof source !== "object") {
    return ""
  }
  return String(
    source.brandIntegration ||
      source.integration ||
      source.integrationCode ||
      source.brand?.integration ||
      source.brand?.integrationCode ||
      ""
  )
    .trim()
    .toLowerCase()
}

/** Brand has Syrve, Foodics or Salasa third-party POS integration. */
export const hasExternalPosIntegration = (source = {}) => {
  const integration = resolveBrandIntegration(source)
  return (
    integration === "syrve" ||
    integration === "salasa" ||
    integration === "foodics"
  )
}

export const isSalasaProvider = (source = {}) =>
  resolveBrandIntegration(source) === "salasa"

export const isSyrveProvider = (source = {}) =>
  resolveBrandIntegration(source) === "syrve"

export const isFoodicsProvider = (source = {}) =>
  resolveBrandIntegration(source) === "foodics"

/** F&B POS (Syrve or Foodics) — shared order list / details UI. */
export const isFnbPosProvider = (source = {}) =>
  isSyrveProvider(source) || isFoodicsProvider(source)
